import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LzThnxForPurchaseComponent } from "../components/lz-thnxForPurchase.component";
import { LzCookieService } from '../../../services/lz-cookie/lz-cookie';

@Injectable()
export class LzThnxForPurchaseService {

  private LzThnxForPurchase: MatDialogRef < LzThnxForPurchaseComponent > ;

  constructor(public dialog: MatDialog, private cookie: LzCookieService) {

  }

  openThnx(options: any): void {
    this.LzThnxForPurchase = this.dialog.open(LzThnxForPurchaseComponent, {
      panelClass: 'myPane',
      data: options
    });
    this.LzThnxForPurchase.afterClosed().subscribe(() => {
      if (this.cookie.getCookie('referer')) {
        window.location.href = decodeURIComponent(this.cookie.getCookie('referer'));
        this.cookie.createCookie('referer', '', 1);
      }
    })
  }

}
